import axios from "axios";
import {
  ListOfActivities,
  ActivitiesRequestPayload,
  DealDetails,
  ListOfDeals,
  DealsRequestPayload,
  DealSummary,
  FilterOptions,
  DealDetailsRequestPayload,
  DealTimelineRequestPayload,
  DealTimeLineResponse,
  NudgeItem,
} from "src/types/dealInsights";

const BASE_URL = process.env.REACT_APP_DEAL_INSIGHTS_API_URL;

const dealsApiUrl = `${BASE_URL}/deals/3.0`;

export const dealInsightsApi = {

  getSummary: async (): Promise<DealSummary> => {
    const response = await axios.get(`${dealsApiUrl}/insights/summary`);
    return response.data;
  },

  getFilterOptions: async (): Promise<FilterOptions> => {
    const response = await axios.get(`${dealsApiUrl}/insights/filter-options`);
    return response.data;
  },

  getDeals: async (payload: DealsRequestPayload): Promise<ListOfDeals> => {
    const response = await axios.post(`${dealsApiUrl}/insights/deals`, payload);
    return response.data;
  },

  getActivities: async (payload: ActivitiesRequestPayload): Promise<ListOfActivities> => {
    const response = await axios.post(`${dealsApiUrl}/insights/activities`, payload);
    return response.data;
  },

  getDealDetail: async ({ dealId }: DealDetailsRequestPayload): Promise<DealDetails> => {
    const response = await axios.get(`${dealsApiUrl}/insights/deals/${dealId}`);
    return response.data;
  },

  getTimeline: async (payload: DealTimelineRequestPayload): Promise<DealTimeLineResponse> => {
    const response = await axios.post(`${dealsApiUrl}/insights/timeline`, payload);
    return response.data;
  },

  syncDeal: async (dealExternalId: string): Promise<any> => {
    const response = await axios.post(`${dealsApiUrl}/${dealExternalId}/sync`);
    return response.data;
  },

  getNudges: async (dealExternalId: string): Promise<Record<string, NudgeItem[]>> => {
     const response = await axios.post(`${dealsApiUrl}/insights/nudges`, {'dealExternalId': dealExternalId});
    return response.data;
  },
};
